import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Collapsed from 'components/Collapsed'
import ReadAloudButton from '../../components/ReadAloudButton/ReadAloudButton'
import ReadAloudPopover from '../../components/ReadAloudPopover/ReadAloudPopover'

class Faq extends Component {
  static displayName = 'Faq'
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        key: PropTypes.string,
        anchor: PropTypes.string,
        /* HTML */
        content: PropTypes.string.isRequired,
      }),
    ).isRequired,
    readAloud: PropTypes.bool,
  }

  static defaultProps = {}

  state = {}

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const anchor = window.location.hash.substr(1)

      if (anchor !== null) {
        this.updateAnchor(anchor)
      }
    }
  }

  updateAnchor = anchor => {
    const item = document.getElementById(`${anchor}`)
    if (item)
      item.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    this.setState(() => ({ anchor }))
  }

  render() {
    const { items, readAloud } = this.props
    const { anchor } = this.state
    return (
      <React.Fragment>
        {readAloud ? (
          <React.Fragment>
            <ReadAloudPopover />
            <ReadAloudButton />
          </React.Fragment>
        ) : null}
        <ul>
          {items.map((item, index) => (
            <li id={item.anchor || ''} key={index} style={{ margin: '0' }}>
              <Collapsed
                {...item}
                isOpen={item.anchor && item.anchor === anchor}
              />
            </li>
          ))}
        </ul>
      </React.Fragment>
    )
  }
}

export default Faq



// WEBPACK FOOTER //
// ./src/modules/Faq/Faq.js